import React from 'react';
import WelcomePickupsWidget from '../../../components/widgets/WelcomePickupsWidget';

function WelcomePickupsForm() {
  return (
    <div>
      <WelcomePickupsWidget />
    </div>
  );
}

export default React.memo(WelcomePickupsForm);
